import { createStore } from "vuex";

export default createStore({
  state: {
    updateValue: "",
  },
  getters: {
    get_update_value: (state) => {
      return state.updateValue;
    },
  },
  mutations: {
    SET_VALUE(state, updateValue) {
      state.updateValue = updateValue;
    },
  },
  actions: {},
  modules: {},
});

